import {
  MENU_CLOSED,
  MENU_OPEN,
  NEW_USER,
  OLD_USER,
  CHANGE_PAGE,
  SAVE_FILTERS,
} from "../utils/actionTypes";

export const toggleMenu = (value) => {
  return (dispatch) => {
    if (value) {
      dispatch({ type: MENU_OPEN });
    } else {
      dispatch({ type: MENU_CLOSED });
    }
  };
};

export const toggleUserType = (new_user) => {
  return (dispatch) => {
    if (new_user) {
      dispatch({ type: NEW_USER });
    } else {
      dispatch({ type: OLD_USER });
    }
  };
};

export const changePage = (page, offset) => {
  return {
    type: CHANGE_PAGE,
    payload: {
      page,
      offset,
    },
  };
};

export const saveFilters = (filters) => {
  return {
    type: SAVE_FILTERS,
    payload: {
      filters,
    },
  };
};



// WEBPACK FOOTER //
// ./src/actions/index.js